import { isDev } from './app-utils';

/**
 * Logs an MSAL event for local/TEST debugging (`isDev()`). Split out of `msal-utils.js` (see that
 * module's own top-level-await comment, and `msal-token.js`'s identical note) so this can be
 * unit-tested directly (`msal-event-logger.test.js`), without the `jest.mock('app/msal-utils', ...)`
 * workaround every other test that needs that module already uses.
 *
 * TASK-009: deliberately logs only `e.eventType`/`e.interactionType`, never `e.payload` (or
 * anything derived from it) - an MSAL event payload carries the idToken/accessToken and their
 * claims, and `isDev()` is now true on TEST too (TASK-011), not just a local dev server, so logging
 * it there would leak live tokens to the browser console/any error-reporting tool that captures it.
 */
export const logMsalEvent = (e) => {
  if (isDev()) {
    console.log('MSAL.EVENT', e.eventType, e.interactionType);
  }
};
